<template>
  <div
    class="accessory-form"
    :class="[props.ismobile ? 'mobile-accessory-form' : '']"
  >
    <div class="accessory-title">{{ accessoryText }}</div>
    <div class="df accessory">
      <template v-for="item in accessoryList" :key="item.searchVal">
        <div class="accessory-item">
          <div class="label">{{ item.label }}</div>
          <a-input-number
            v-model:value="item.val"
            @change="checkNumber(item)"
            :disabled="props.disabled"
            :class="[props.ismobile ? 'mobile-input' : '']"
          ></a-input-number>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { computed, defineComponent, reactive, ref, watch } from "vue";
import {
  standardConfigOptions,
  optionalOptions,
} from "@/views/repairprogress/serve/accessory";
import { Toast } from "@/utils";

export default defineComponent({
  props: {
    // 天鸽天鹅
    machine: String,
    // standard optional
    accessory: String,
    // 回显列表
    echoList: Array,
    disabled: Boolean,
    ismobile: Boolean,
  },
  setup(props, context) {
    const machineType = ref(null);
    const accessoryType = ref(null);
    const accessoryText = ref("");
    // // 选配标配列表
    const accessoryList = reactive([]);
    // 校正数字
    const checkNumber = (accessoryItem) => {
      if (typeof accessoryItem.val !== "number") {
        accessoryItem.val = null;
      }
    };
    // 校验选择的配件数量不为0
    const validateSelectList = () => {
      return new Promise((resolve, reject) => {
        resolve(accessoryList);
      });
      // return new Promise((resolve, reject) => {
      //   // 选配不必填
      //   if (
      //     accessoryInputList.length === 0 &&
      //     accessoryType.value !== "standard"
      //   ) {
      //     resolve([]);
      //     return;
      //   }
      //   if (accessoryInputList.length === 0) {
      //     return Toast("warning", `请选择${accessoryText.value}件`, 3);
      //   }
      //   // 标配必填
      //   const unInputList = accessoryInputList.filter((item) => item.val === 0);
      //   if (unInputList.length > 0) {
      //     Toast("warning", `${accessoryText.value}件数量不能为0`, 3);
      //     reject();
      //     return;
      //   }
      //   resolve(accessoryInputList);
      // });
    };
    // 重置选项
    const resetSelect = () => {
      accessoryList.length = 0;
    };

    const setListData = () => {
      const list =
        props.accessory === "standard"
          ? standardConfigOptions()[machineType.value]
          : optionalOptions()[machineType.value];
      accessoryList.length = 0;
      accessoryList.push(...list);
    };
    watch(
      () => props.machine,
      (val) => {
        if (val) {
          machineType.value = val.replace(/[^\u4E00-\u9FA5]/g, "");
          setListData();
        }
      },
      {
        immediate: true,
        deep: true,
      }
    );
    watch(
      () => props.accessory,
      (val) => {
        if (val) {
          accessoryText.value = val === "standard" ? "标配" : "选配";
          setListData();
        }
      },
      {
        immediate: true,
        deep: true,
      }
    );
    const echoAccessorySelectedList = (list) => {
      accessoryList.forEach((item) => {
        const findItem = list.find((find) => find.searchVal === item.searchVal);
        if (findItem) {
          item.val = findItem.val;
        } else {
          item.val = 0;
        }
      });
      // const echoList = list.filter(
      //   (item) =>
      //     accessoryList.value.filter((find) => {
      //       if (find.searchVal === item.searchVal) {
      //         item.label = find.label;
      //       }
      //       return find.searchVal === item.searchVal;
      //     }) > 0
      // );

      // accessoryInputList.push(...echoList);
    };
    watch(
      () => props.echoList,
      (val) => {
        if (val) {
          echoAccessorySelectedList(val);
        }
      },
      {
        immediate: true,
        deep: true,
      }
    );

    return {
      accessoryList,
      accessoryText,
      checkNumber,
      validateSelectList,
      resetSelect,
      props,
    };
  },
});
</script>

<style lang="less" scoped>
.accessory-form {
  .accessory-title {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 20px;
    text-align: center;
  }
  .accessory {
    flex-wrap: wrap;
    .accessory-item {
      width: 33%;
      display: flex;
      margin-bottom: 10px;
    }
  }
  .label {
    width: 130px;
  }
}

.mobile-accessory-form {
  .accessory {
    flex-wrap: wrap;
    justify-content: space-between;
    .accessory-item {
      width: 48%;
      display: flex;
      margin-bottom: 10px;
      .mobile-input {
        width: 60px;
      }
    }
  }
}
</style>
